import React, { useState } from "react";

// make a new context
export const AppContext = React.createContext();

// create the provider
export const AppProvider = ({ children }) => {
  // const [menuOpenState, setMenuOpenState] = useState(false);

  // const [viewBox, setViewBox] = useState("0 0 100 100");
  const [minX, setMinX] = useState(0);
  const [minY, setMinY] = useState(0);
  const [width, setWidth] = useState(100);
  const [height, setHeight] = useState(100);

  const [points, setPoints] = useState(null);
  const [numPoints, setNumPoints] = useState(20);

  const appContext = {
    minX: minX,
    minY: minY,
    width: width,
    height: height,
    minXChangeHandler: (newState) => setMinX(newState),
    minYChangeHandler: (newState) => setMinY(newState),
    widthChangeHandler: (newState) => setWidth(newState),
    heightChangeHandler: (newState) => setHeight(newState),
    points: points,
    pointsChangeHandler: (newState) => setPoints(newState),
    numPoints: numPoints,
    numPointsChangeHandler: (newState) => setNumPoints(newState),
  };

  return (
    <AppContext.Provider value={appContext}>{children}</AppContext.Provider>
  );
};
